import React from 'react';
import './Spinner.css';

const Spinner = () => {
    return (
        <div className="spinner">
            <div className="spinner__content"></div>
        </div>
    );
};

export default Spinner;
